/* eslint-disable @typescript-eslint/no-explicit-any */
import * as R from 'ramda'

type Tail<T extends any[]> = ((...t: T) => any) extends ((_: any, ...tail: infer TT) => any) ? TT : []
type HasTail<T extends any[]> = T extends ([] | [any]) ? false : true

type Curry<P extends any[], R> = <T extends any[]>(...args: T) => HasTail<P> extends true ? Curry<Tail<T>, R> : R

export function curryExts<P extends any[], R> (f: (...args: P) => R): Curry<P, R> {
  return R.curry(f)
}
